import React from "react";

export const Tabs = ({ tabsData, active, setActive }) => {
  return (
    <>
      <div className="bg-white border py-1 px-1 mt-2 w-fit  rounded-lg">
        {tabsData.map((item, index) => (
          <button
            onClick={() => {
              setActive(item);
            }}
            className={`text-xs font-medium px-2 rounded-lg py-2  ${
              active?.index === index ? "bg-main text-black" : "bg-white"
            }`}
          >
            {item.value}
          </button>
        ))}
      </div>
    </>
  );
};
